import React, { useEffect, useState } from 'react';
import { FormComponent, FormComponentProps } from '../index';
import { useWatch } from 'react-hook-form';

export default function Switch(
  trueElements: FormComponent | FormComponent[],
  falseElements: FormComponent | FormComponent[],
  switchOn: any,
  callback?: (watchValues: any) => boolean | Promise<boolean>
): FormComponent {
  return ({ ...rest }) => (
    <SwitchComponent
      trueElements={Array.isArray(trueElements) ? trueElements : [trueElements]}
      falseElements={
        Array.isArray(falseElements) ? falseElements : [falseElements]
      }
      switchOn={switchOn}
      callback={callback}
      {...rest}
    />
  );
}

export function SwitchComponent({
  trueElements,
  falseElements,
  switchOn,
  callback,
  ...rest
}: FormComponentProps & {
  trueElements: FormComponent[];
  falseElements: FormComponent[];
  switchOn: any;
  callback?: (watchValues: any) => boolean | Promise<boolean>;
}) {
  const watchValues = useWatch({ name: switchOn });

  const [showValue, setShowValue] = useState(false);
  useEffect(() => {
    if (callback) {
      Promise.resolve(callback(watchValues)).then((value) =>
        setShowValue(value)
      );
    } else {
      if (Array.isArray(watchValues)) {
        setShowValue(!watchValues.filter(Boolean));
      } else {
        setShowValue(!watchValues);
      }
    }
  }, [watchValues, callback]);

  return (
    <>
      {(showValue ? trueElements : falseElements).map((Element, index) => (
        <Element key={index} {...rest} />
      ))}
    </>
  );
}
